import AppButton from "@/components/AppButton.vue";
import CompletedOrdersCard from "@/components/CompletedOrdersCard.vue";
import EmptyState from "@/components/EmptyState.vue";
import ListDefault from "@/components/ListDefault.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import NotificationPermissionModal from "@/components/NotificationPermissionModal.vue";
import ThreeOptionsListOrd from "@/components/ThreeOptionsListOrd.vue";
import HomeContainer from "@/containers/HomeContainer.vue";
import { initializeFirebase } from "@/firebaseInit";
import GoogleTagManagerService from "@/services/google-tag-manager.service";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import moment from "moment";
import ModalPixPending from "orders-module/src/components/ModalPixPending.vue";
import { Component, Vue } from "vue-property-decorator";

declare let M: any;
declare let $: any;
declare const fbq: any;
@Component({
  components: {
    ModalCodigo,
    AppButton,
    Option,
    ListDefault,
    ThreeOptionsListOrd,
    EmptyState,
    HomeContainer,
    CompletedOrdersCard,
    NotificationPermissionModal,
    ModalPixPending,
  },
})
export default class PedidosRealizados extends Vue {
  orders: any = JSON.parse(sessionStorage.getItem("ORDERS") || "[]");
  currentOrders: Array<object> = JSON.parse(
    sessionStorage.getItem("EXTRATO_CURRENT_ORDERS") || "[]"
  );
  finishedOrders: Array<object> = JSON.parse(
    sessionStorage.getItem("EXTRATO_FINISHED_ORDERS") || "[]"
  );
  cancelledOrders: Array<object> = JSON.parse(
    sessionStorage.getItem("EXTRATO_CANCELED_ORDERS") || "[]"
  );
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "[]");

  notFound = false;
  notFoundCurrent = false;
  notFoundFinished = false;
  notFoundCancelled = false;
  ordersPixPending: any = [];

  abas: any = [
    { id: 1, NAME: "Em Andamento" },
    { id: 3, NAME: "Pedidos Anteriores" },
  ];
  qrMesa: boolean = JSON.parse(sessionStorage.getItem("QRMesa") || "false");
  loadedOrders: boolean = sessionStorage.getItem("ORDERS") ? true : false;
  deviceToken = sessionStorage.getItem("DEVICE_TOKEN");

  hasPixel: any = JSON.parse(sessionStorage.getItem("hasPixel") || "false");
  time: number = 5 * 60;
  counter: any = { min: 0, sec: 0 };
  progress: any = 100;
  total = 300;
  showModal = false;
  modalMessage = "";
  modalMessageTop = "";
  currentOrder: any = undefined;
  showNotificationModal = false;
  lastOrderId: string | null = null;
  intervalNotificationPermission: any = null;
  itHappened = false;
  showModalPix = false;
  errorMessagePixPending = "";

  created() {
    const currentStructure = JSON.parse(
      sessionStorage.getItem("currentStructure") || "{}"
    );
    if (
      sessionStorage.getItem("SEND_TO_ORDER") &&
      !currentStructure.integrationCommands
    ) {
      this.$router.replace("Pedido");
    } else if (
      sessionStorage.getItem("SEND_TO_ORDER") &&
      currentStructure.integrationCommands
    ) {
      this.$router.replace("VerPedido");
    }
  }
  async mounted() {
    if (
      sessionStorage.getItem("SEND_TO_ORDER") &&
      sessionStorage.getItem("IDTABLE")
    ) {
      return;
    } else if (!JSON.parse(sessionStorage.getItem("honestMarket") || "false")) {
      sessionStorage.setItem("CURRENT_ORDER", "");
    }

    if (this.hasPixel) {
      fbq("trackCustom", "viewOrders");
    }
    Util.setBackButtonBehavior(this.goBack);
    this.getOrdersFromUserInOrganization();
    this.goToCorrectTab();
    this.scrollToTop();
    this.checkPixPending();

    this.lastOrderId = sessionStorage.getItem("LAST_ORDER_ID") || null;
    this.intervalNotificationPermission = setInterval(
      () => this.checkAndHandleNotificationPermission(),
      5000
    );
  }

  async checkAndHandleNotificationPermission(): Promise<void> {
    const permissionStatus = Notification.permission;
    if (!this.deviceToken)
      this.deviceToken = sessionStorage.getItem("DEVICE_TOKEN");

    const orderId =
      this.orders && this.orders[0] ? this.orders[0].orderId : null;

    if (
      (permissionStatus !== "granted" || !this.deviceToken) &&
      !this.itHappened
    ) {
      this.showNotificationModal = true;
    } else if (permissionStatus === "granted" && this.deviceToken && orderId) {
      await this.updateOrderDeviceId(orderId, this.deviceToken);
    }
    this.itHappened = true;
  }

  async handleNotificationModalOk(): Promise<void> {
    this.showNotificationModal = false;

    try {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        await initializeFirebase();
        await this.checkAndLinkDeviceToken();
      } else {
        console.warn(
          "Permissão de notificação negada ou bloqueada pelo usuário."
        );
      }
    } catch (err) {
      console.error(
        "Erro ao solicitar permissão de notificação via modal:",
        err
      );
    }
  }

  async checkAndLinkDeviceToken(): Promise<void> {
    if (!this.deviceToken)
      this.deviceToken = sessionStorage.getItem("DEVICE_TOKEN");

    const orderId =
      this.orders && this.orders[0] ? this.orders[0].orderId : null;

    if (this.deviceToken && orderId) {
      console.log("DEVICE_TOKEN obtido para vinculação:", this.deviceToken);
      await this.updateOrderDeviceId(orderId, this.deviceToken);
    } else {
      console.log("DEVICE_TOKEN não disponível ou lastOrderId ausente.");
    }
  }

  async updateOrderDeviceId(
    orderId: string | null,
    deviceId: string
  ): Promise<void> {
    try {
      clearInterval(this.intervalNotificationPermission);
      return new Promise((resolve, reject) => {
        const req = new Request();
        req.route = "addDeviceToken";
        req.body = {
          USER_ID: sessionStorage.getItem("USER_ID"),
          NRORG: sessionStorage.getItem("NRORG"),
          TOKEN: sessionStorage.getItem("TOKEN"),
          ORDER_ID: orderId,
          DEVICE_TOKEN: deviceId,
        };
        req.callbackSuccess = () => {
          this.lastOrderId = null;
          resolve;
        };
        req.callbackError = (error: any) => {
          console.error(error);
          reject;
        };
        req.send();
      });
    } catch (error) {
      console.warn("Erro ao vincular device_id ao pedido:", error);
    }
  }

  goToCorrectTab() {
    const path = window.location.href.split("/");
    const pathName = path[path.length - 1];
    if (pathName.includes("#")) {
      const tabName = pathName.split("#")[1];
      const instance = M.Tabs.getInstance($("#tabs"));
      instance.select(tabName);
    }
  }

  goBack() {
    const homeLayout = this.verifyRouteHome();
    this.$router.push(homeLayout);
  }

  verifyRouteHome() {
    const util: any = new Util();
    const homeLayout: any = util.verifyRouteHome();
    return homeLayout;
  }

  formatDate(date: string) {
    const dateD = new Date(date);
    const dia = dateD.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (dateD.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = dateD.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  }
  //subtract colocado como solução temporária devido a hora errada no servidor
  formatDateTime(stringDate: string) {
    const momentDate: any = moment(stringDate).subtract(1, "hours");
    return momentDate.lang("pt-br").format("dddd, DD/MMM [às] HH:mm");
  }

  clickOrder(orderId: any) {
    sessionStorage.setItem("ORDER_ID", orderId + "");
    this.$router.push("ExtratoPedido");
  }

  scrollToTop() {
    document.body.scrollTo(0, 0);
  }

  getOrdersFromUserInOrganization() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        TIMEZONE: Util.getTimezone(),
      };
      req.route = "getOrdersFromUser";
      req.callbackSuccess = function (response: any) {
        self.orders = response.orders;
        if (self.orders.length == 0) self.notFound = true;
        else self.notFound = false;

        const currentOrders = self.orders.filter(
          (s: any) => s.isFinished == false
        );
        self.currentOrders = currentOrders;
        if (self.currentOrders.length == 0) self.notFoundCurrent = true;
        else self.notFoundCurrent = false;

        const finishedOrders = self.orders.filter(
          (s: any) => s.isFinished == true && s.cancelled == false
        );
        self.finishedOrders = finishedOrders;
        if (self.finishedOrders.length == 0) self.notFoundFinished = true;
        else self.notFoundFinished = false;
        // self.orders = currentOrders.concat(finishedOrders)

        const cancelledOrders = self.orders.filter(
          (s: any) => s.cancelled == true
        );
        self.cancelledOrders = cancelledOrders;
        if (self.cancelledOrders.length == 0) self.notFoundCancelled = true;
        else self.notFoundCancelled = false;

        sessionStorage.setItem("ORDERS", JSON.stringify(self.orders));
        sessionStorage.setItem(
          "EXTRATO_CURRENT_ORDERS",
          JSON.stringify(self.currentOrders)
        );
        sessionStorage.setItem(
          "EXTRATO_FINISHED_ORDERS",
          JSON.stringify(self.finishedOrders)
        );
        sessionStorage.setItem(
          "EXTRATO_CANCELED_ORDERS",
          JSON.stringify(self.cancelledOrders)
        );
        self.loadedOrders = true;

        //const currentOrders = response.orders.filter((order: any) => order.orderStatus != 'Entregue' && order.orderStatus != 'Cancelado');
        //sessionStorage.setItem('CURRENT_ORDERS', JSON.stringify(currentOrders));
      };
      req.callbackError = function (error: any) {
        console.log(error);
        self.notFound = true;
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  checkPixPending() {
    try {
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getUserOrderPixPending";
      req.callbackSuccess = (response: any) => {
        const orders = response.orders || null;

        if (orders && orders.STATUS === "orderCanceled") {
          this.$toast.error(
            "O pedido PIX" + orders.ORDER_IDENTIFIER + " foi cancelado."
          );
          this.mostraModal(
            "Pedido Cancelado",
            "O pedido PIX " +
              orders.ORDER_IDENTIFIER +
              " foi cancelado. Para mais informações entre em contato com a loja."
          );
          this.getOrdersFromUserInOrganization();
          return;
        }

        if (
          !orders ||
          orders === "Nenhum pedido pix pendente" ||
          orders === "Sem id do usuario ainda" ||
          (Array.isArray(orders) && typeof orders[0] === "string")
        ) {
          return;
        }

        const validOrder = orders.find((o: any) => o.order);

        if (validOrder.order.status == 7) {
          this.$toast.error(
            "O pedido " +
              validOrder.order.orderIdentifier +
              " foi cancelado pela falta de pagamento."
          );
          this.getOrdersFromUserInOrganization();
        } else {
          this.ordersPixPending = validOrder.order;

          sessionStorage.setItem(
            "QR_CODE_PIX",
            JSON.stringify(validOrder.qrCodePix)
          );
          sessionStorage.setItem(
            "QR_CODE_URL_PIX",
            JSON.stringify(validOrder.qrCodeUrlPix)
          );

          this.showModalPix = true;
          this.errorMessagePixPending = `Pagamento pendente para o pedido ${validOrder.order.orderIdentifier}`;
        }
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  shouldShowDate(
    orders: { createDate: { date: string } }[],
    index: number
  ): boolean {
    if (index === 0) return true;

    const currentDate = orders[index].createDate.date.split(" ")[0];
    const previousDate = orders[index - 1].createDate.date.split(" ")[0];

    return currentDate !== previousDate;
  }

  formatDateForHistory(dateString: string): string {
    const [year, month, day] = dateString.split(" ")[0].split("-").map(Number);

    const date = new Date(year, month - 1, day);

    const formatted = new Intl.DateTimeFormat("pt-BR", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(date);

    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }

  mostraModal(messageTop: string, message: string) {
    this.modalMessageTop = messageTop;
    this.modalMessage = message;
    this.showModal = true;
  }

  fechaModal() {
    this.showModal = false;
  }

  async addToCart(order: any) {
    const products: any = await this.getStoreAndProductsData(
      order.storeId,
      order.bodySaveOrder
    );

    if (products) {
      if (sessionStorage.getItem("STORE")) {
        sessionStorage.removeItem("STORE");
        sessionStorage.removeItem("CURRENT_ORDER");
        sessionStorage.removeItem("ITEMS");
        sessionStorage.removeItem("DELIVERY_DATA");
      }

      this.currentOrder = {
        DELIVER_TO: order.deliverTo,
        STORE_ID: order.storeId,
        DISCOUNT: 0,
        CUPOM_ID: null,
        TOTAL_VALUE: 0,
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        ORDER_ITEMS: [],
        STRUCTURE_ID: null,
        STRUCTURE_NAME: null,
        AMOUNT_OF_ITEMS: 0,
      };

      let amountOfItems = 0;

      const items = products.map((product: any, index: number) => {
        const addItem = order.bodySaveOrder.find(
          (item: any) => item.productId == product.id
        );

        if (
          parseInt(addItem.quant) == product.amount &&
          product.blockOrderWithNoStock
        ) {
          product.disabledBtnAdd = true;
        } else {
          product.disabledBtnAdd = false;
        }

        let idProd = addItem.productId;
        if (addItem.type == "pizza")
          idProd = idProd + "." + addItem.extras[0].limitQuantityMin;

        const quant = parseInt(addItem.quant, 10);

        let basePrice = product.price || addItem.basePrice;

        let extrasTotal = 0;

        if (addItem.extras && addItem.extras.length) {
          addItem.extras.forEach((extra: any) => {
            if (extra.selectedOptions && extra.selectedOptions.length) {
              extra.selectedOptions.forEach((option: any) => {
                const optionPrice = Number(option.price) || 0;
                const optionQuantity = Number(option.quantity) || 1;
                extrasTotal += optionPrice * optionQuantity;
              });
            }
          });
        }

        let priceUnitTotal = basePrice + extrasTotal;
        let price = priceUnitTotal * quant;

        // mantém regra especial de combo
        if (addItem.type === "combo") {
          basePrice = this.calculatePriceFromExtras(addItem.extras, true);
          priceUnitTotal = this.calculatePriceFromExtras(addItem.extras, false);
          price = priceUnitTotal * quant;
        }

        const item = {
          quant: quant,
          productName: addItem.productName,
          itemId: index,
          note: "",
          extras: addItem.extras,
          productId: idProd,
          estimatedTime: product.estimatedTime,
          price: price,
          priceUnitTotal: priceUnitTotal,
          basePrice: basePrice,
          menuId: product.menuId,
          externalId: product.originalProduct.externalId,
          disabledBtnAdd: product.disabledBtnAdd,
          productAmount: product.amount,
          blockOrderWithNoStock: product.blockOrderWithNoStock,
          type: addItem.type ? addItem.type : "default",
        };

        amountOfItems += item.quant;

        if (window.dataLayer) {
          GoogleTagManagerService.pushDataLayer({
            event: "add_to_cart",
            items: [
              {
                item_id: item.productId,
                item_name: item.productName,
                item_category: product.productGroupId || "",
                quantity: item.quant,
                price: item.priceUnitTotal,
              },
            ],
          });
        }

        return item;
      });

      this.currentOrder.ORDER_ITEMS = items;
      this.currentOrder.TOTAL_VALUE = this.calcTotalPrice();
      this.currentOrder.AMOUNT_OF_ITEMS = amountOfItems;

      sessionStorage.setItem(
        "CURRENT_ORDER",
        JSON.stringify(this.currentOrder)
      );
      sessionStorage.setItem("ITEMS", JSON.stringify(this.currentOrder));
      sessionStorage.setItem("DELIVER_AT", order.deliverTo);

      this.goToStore(order.storeId);
    }
  }

  calculatePriceFromExtras(extras: any[], onlyRequired = false): number {
    let total = 0;

    for (const extra of extras) {
      if (onlyRequired && !extra.required) {
        continue;
      }

      if (extra.selectedOptions && extra.selectedOptions.length > 0) {
        for (const option of extra.selectedOptions) {
          total += parseFloat(option.price) * option.quantity;
        }
      }
    }

    return total;
  }

  calcTotalPrice() {
    let totalPrice = 0;
    if (this.currentOrder.ORDER_ITEMS.length > 0) {
      this.currentOrder.ORDER_ITEMS.forEach((item: any) => {
        totalPrice += item.priceUnitTotal * item.quant;
        item.price = item.priceUnitTotal * item.quant;
      });
    }
    if (this.currentOrder.DISCOUNT > 0)
      return totalPrice - this.currentOrder.DISCOUNT;
    return totalPrice;
  }

  getDeviceTime() {
    moment.locale("pt-br");
    const deviceTime: any = moment().format("LT");
    return deviceTime;
  }

  getStoreAndProductsData(storeId: number, items: any) {
    return new Promise((resolve, reject) => {
      const req = new Request();
      req.route = "getStoreData";
      req.showLoader = true;
      req.body = {
        STORE_ID: storeId,
        ALL_MENUS: "NO",
        DELIVER_AT: "",
        DEVICE_TIME: this.getDeviceTime(),
      };

      req.callbackSuccess = async (response: any) => {
        const store = response.store;
        const storeIsOpen = store.opened;

        if (!storeIsOpen) {
          this.mostraModal(
            "Esta loja está fechada no momento.",
            "Tente adicionar os produtos ao carrinho mais tarde, quando a loja estiver aberta. Você ainda pode acessar o cardápio à vontade."
          );
          resolve(false);
          return;
        }

        const allProductGroups = store.menus.currentWorkshift.flatMap(
          (menu: any) => menu.productGroups
        );

        const validationResults = await Promise.all(
          items.map(async (orderedItem: any) => {
            if (orderedItem.type === "pizza") {
              const flavorExtra = orderedItem.extras.find(
                (extra: any) => extra.name === "Sabor"
              );
              if (!flavorExtra || !flavorExtra.selectedOptions.length)
                return null;

              const firstFlavorId = flavorExtra.selectedOptions[0].id;

              let pizzaProductGroup: any = null;
              for (const group of allProductGroups) {
                if (group.products.some((p: any) => p.id == firstFlavorId)) {
                  pizzaProductGroup = group;
                  break;
                }
              }

              if (!pizzaProductGroup || pizzaProductGroup.type !== "pizza")
                return null;

              const sizeIsValid = pizzaProductGroup.productGroupPizzaSize.some(
                (size: any) => size.id == orderedItem.productId && size.status
              );
              if (!sizeIsValid) return null;

              for (const selectedFlavor of flavorExtra.selectedOptions) {
                const flavorInMenu = pizzaProductGroup.products.find(
                  (p: any) => p.id == selectedFlavor.id
                );

                if (!flavorInMenu || flavorInMenu.status !== "A") return null;

                if (
                  flavorInMenu.blockOrderWithNoStock &&
                  (flavorInMenu.amount === 0 ||
                    parseFloat(orderedItem.quant) > flavorInMenu.amount)
                ) {
                  return null;
                }
              }

              for (const orderedExtra of orderedItem.extras) {
                if (orderedExtra.name === "Sabor") continue;

                let sourceArray: any[] = [];
                if (orderedExtra.name === "Massa") {
                  sourceArray = pizzaProductGroup.productGroupPizzaCrusts;
                } else if (orderedExtra.name === "Borda") {
                  sourceArray = pizzaProductGroup.productGroupPizzaEdges;
                }

                if (sourceArray.length > 0) {
                  for (const selectedOption of orderedExtra.selectedOptions) {
                    const optionExists = sourceArray.some(
                      (opt: any) =>
                        opt.id == selectedOption.id &&
                        (opt.status === undefined || opt.status === true)
                    );
                    if (!optionExists) return null;
                  }
                }
              }

              const pizzaSizeDetails =
                pizzaProductGroup.productGroupPizzaSize.find(
                  (s: any) => s.id == orderedItem.productId
                );
              return {
                id: orderedItem.productId,
                name: orderedItem.productName,
                type: "pizza",
                price: orderedItem.priceUnitTotal,
                amount: 1,
                blockOrderWithNoStock: false,
                originalProduct: { externalId: pizzaSizeDetails.externalId },
                menuId: pizzaProductGroup.products[0]?.menuId,
              };
            } else {
              let productInMenu: any = null;
              for (const group of allProductGroups) {
                const found = group.products.find(
                  (p: any) => p.id == orderedItem.productId
                );
                if (found) {
                  productInMenu = found;
                  break;
                }
              }

              if (!productInMenu) return null;

              if (
                productInMenu.blockOrderWithNoStock &&
                (productInMenu.amount === 0 ||
                  parseFloat(orderedItem.quantity) > productInMenu.amount)
              ) {
                return null;
              }

              await this.verifyGetExtras(productInMenu, storeId);
              if (orderedItem.extras && orderedItem.extras.length > 0) {
                for (const orderedExtra of orderedItem.extras) {
                  const menuExtra = productInMenu.extras.find(
                    (extra: any) => extra.id === orderedExtra.id
                  );
                  if (!menuExtra) return null;

                  for (const selectedOption of orderedExtra.selectedOptions) {
                    if (
                      !menuExtra.options.some(
                        (option: any) => option.id === selectedOption.id
                      )
                    ) {
                      return null;
                    }
                  }
                }
              }

              return {
                ...productInMenu,
                price: productInMenu.price,
                originalProduct: { externalId: productInMenu.externalId },
              };
            }
          })
        );

        const validProducts = validationResults.filter((p) => p !== null);

        const allItemsAvailable = items.length === validProducts.length;

        if (!allItemsAvailable) {
          this.mostraModal(
            "Itens do pedido indisponíveis.",
            "Alguns itens desta compra estão indisponíveis no momento, seja por falta de estoque, extras ou restrições de horário. Você pode tentar novamente mais tarde ou acessar o cardápio da loja para adicionar os produtos disponíveis."
          );
          resolve(false);
        } else {
          resolve(validProducts);
        }
      };

      req.callbackError = (error: any) => {
        console.error(error);
        reject(false);
      };

      req.send();
    });
  }

  verifyGetExtras(product: any, storeId: number) {
    return new Promise((resolve, reject) => {
      const req = new Request();
      req.route = "getExtras";
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        EVENT_ID: storeId,
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        PRODUCT_ID: product.id,
      };
      req.callbackSuccess = (response: any) => {
        product.extras = response.extras;
        resolve(true);
      };
      req.callbackError = (error: any) => {
        console.error(error);
        reject(false);
      };
      req.send();
    });
  }

  goToStore(storeId: number) {
    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("GO_TO_STORE", "true");

    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }
    });
  }

  async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    this.$router.push(path);
  }
}
